import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { DialogDeleteConfirmationData } from './models/dialog-delete-confirmation-data';

import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-delete-folder-confirmation',
    templateUrl: './delete-folder-confirmation.component.html',
    styleUrls: ['./delete-folder-confirmation.component.scss'],
    imports: [MatCardModule, MatCheckboxModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatDialogClose]
})
export class DeleteFolderConfirmationComponent {
    /**
     * Contrôle de formulaire pour confirmer la suppression.
     */
    public confirmFormControl = new UntypedFormControl();

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<DeleteFolderConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogDeleteConfirmationData
    ) {}
}
